import { Dispatch, SetStateAction } from 'react';
import { TFunction } from 'react-i18next';

import { LabelValue } from '../../../types/options';
import { noColumnStyle } from '../../../utils/constants/tables';
import { dateCell } from '../../../utils/helpers/dataTable';
import ActionsTableMenu from '../Components/ActionsTableMenu/ActionsTableMenu';

export type PaymentsType = {
  id: number;
  orderId: number;
  createdAt: string | null;
  modifiedAt: string | null;
  amount: number | null;
  paymentTypeId: number | null;
  paymentStatusId: number | null;
  customerName: string | null;
  posTerminalName: string | null;
  posTerminalId: string | null;
  serialNumber: string | null;
};

export const tableStorageKey = 'payments_dataTable';

export function getColumnHeadersMap(t: TFunction) {
  return {
    no: t('No.'),
    createdAt: t('Created Date'),
    customerName: t('Customer Name'),
    debtorName: t('Chargee'),
    paymentTypeName: t('Payment type'),
    paymentStatusName: t('Payment status'),
    posTerminalName: t('Smart POS Terminals'),
    serialNumber: t('Serial Number'),
    amount: t('Amount'),
    modifiedAt: t('Modified Date'),
  };
}

export function additionalColumnProperties(
  t: TFunction,
  column: keyof ReturnType<typeof getColumnHeadersMap> | 'actions',
  setContextMenuSelection: Dispatch<SetStateAction<any>>,
  setAction: (t: string) => void,
  setCaller: Dispatch<SetStateAction<'context-menu' | 'group-actions'>>,
  readGuard: boolean
) {
  switch (column) {
    case 'no':
      return {
        noColumnStyle,
        style: {
          width: 30,
          maxWidth: 30,
        },
        bodyStyle: {
          width: 30,
          maxWidth: 30,
          display: 'flex',
          textAlign: 'center',
        },
      };

    case 'createdAt':
    case 'modifiedAt':
      return {
        body: (row: PaymentsType) => dateCell(row[column] ?? ''),
        style: {
          width: 180,
        },
        bodyStyle: {
          width: 180,
        },
      };

    case 'amount':
      return {
        style: {
          width: 120,
        },
        bodyStyle: {
          width: 120,
        },
      };
    case 'debtorName':
    case 'customerName':
    case 'paymentTypeName':
    case 'paymentStatusName':
    case 'posTerminalName':
    case 'serialNumber':
      return {
        style: {
          width: 250,
        },
        bodyStyle: {
          width: 250,
        },
      };

    case 'actions':
      return {
        body: (row: PaymentsType) => {
          return (
            <ActionsTableMenu
              actions={[
                {
                  label: t('View Details'),
                  icon: 'fas fa-search',
                  disabled: !readGuard,
                  command: () => {
                    setContextMenuSelection(row);
                    setAction('view-details');
                    setCaller('context-menu');
                  },
                },
              ]}
            />
          );
        },
        style: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
        },
        bodyStyle: {
          width: 60,
          borderLeft: '1px solid #e9ecef',
          flex: '0 1 auto',
          position: 'sticky',
          justifyContent: 'center',
        },
      };

    default:
      return {};
  }
}

export function paymentsStatuses(t: TFunction): LabelValue[] {
  return [
    { label: t('Paid'), value: '1' },
    { label: t('Cancelled'), value: '2' },
    { label: t('Issued'), value: '3' },
  ];
}

export function paymentsTerminalOptions(t: TFunction): LabelValue[] {
  return [
    { label: t('Cash'), value: '1' },
    { label: t('Invoice'), value: '2' },
    { label: t('POS'), value: '3' },
    { label: t('VirtualPOS'), value: '4' },
    { label: t('SmartPOS'), value: '5' },
  ];
}
